
<button *ngIf="hasValue()" (click)="onClick()" type="button" style="width: 60px;" title="{{params.Tooltip}}">
        <mat-icon class="iconsize-16 mat-icon material-icons">{{icon}}</mat-icon>
    </button>
    


// WEBPACK FOOTER //
// ./src/app/shared/grid/buttons/cell-button.component.ts.CellButtonComponent.html